<template>
<div>
    <div class="row">
        <div class="col-xs-12">
            <div class="form-group">
                <select class="form-control" 
                        v-model="resourceId">
                    <option v-for="(resource, index) in settings.resources" 
                            :key="index"
                            :value="resource.resourceId">
                        {{ resource.resourceName }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-6">
            <label>{{ $_locale('date') }}</label>
            <input type="text" class="form-control" ref="dateInput" />
        </div>
        <div class="col-xs-6">
            <div class="form-group">
                <label>{{ $_locale('tee time') }}</label>
                <input class="form-control time-picker" 
                        type="time"
                        v-model="startTime" />
            </div>
        </div>
    </div>
    <!--
    <div class="row" v-if="!edit.disabled && [2,3].indexOf(edit.status) > -1">
        <div class="col-xs-12">
            <div class="form-group">
                <div class="input-group">
                    <input class="form-control" 
                        v-model="edit.totalPrice"
                        type="text" 
                        autocomplete="off"
                        style="text-align:right;">
                    <span class="input-group-addon">{{ $_CURRENCY_SYMBOL }}</span>
                </div>
            </div>
        </div>
    </div>
    -->
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { durationToBlockCount } from '../common/ReservationService.js'

export default {
    props: {
        defaultDate: {
            type: Object,
            required: true,
        },
        defaultResourceId: {
            type: Number,
            required: true,
        }
    },
    data: () => ({
        resourceId: null,
        startTime: null,
        date: null,
    }),
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            editReservation: 'calendar/editReservation',
            activeReservation: 'calendar/activeReservation',
            orderLinkUrl: 'ecom/orderLinkUrl',
            settings: 'reservations/settings',
            service: 'reservations/service',
            mobile: 'common/mobile',
        }),
    },
    methods: {
        setResourceId(resourceId) {
            this.resourceId = resourceId;
        },
        setStartTime(startTime, updateInput = true) {
            this.startTime = moment(startTime).format('HH:mm');
            this.date = moment(startTime);

            if (!updateInput) return;

            const { daterangepicker } = window.wisenetwork
            const input = this.$refs.dateInput;
            const bounding = input.getBoundingClientRect();
            const settings = {
                locale: { 
                    format: 'dd DD.MM.YYYY',
                    daysOfWeek: _localeDates.dayNamesMin,
                    monthNames: _localeDates.monthNamesShort,
                    firstDay: 1,
                },
                showWeekNumbers: true,
                singleDatePicker: true,
                showDropdowns: true,
                startDate: startTime,
            };

            if (window.innerHeight - bounding.y < 320) {
                settings.drops = 'up';
            } else {
                settings.opens = 'right';
            }
            
            if (this.mobile) {
                input.readOnly = true;
            }
            
            daterangepicker(
                input,
                settings, 
                (startDate, endDate) => {
                    this.date = startDate;
                }
            )
        },
        getResourceName() {
            const resource = this.settings.resources.filter(row => row.resourceId == this.resourceId)[0]
            
            return resource.resourceName;
        },
        formatReservation(reservation) {
            const service = this.service;
            const formatCurrency = this.$_formatCurrency;
            const baseDate = moment(this.date).clone();
            var startTime = this.startTime.split(':');
            var dateTimeStart = baseDate.clone();

            dateTimeStart.set({ hour: startTime[0], minute: startTime[1], second: 0, millisecond: 0 });
            
            var dateTimeEnd = dateTimeStart.clone();

            dateTimeEnd.add(10, 'minutes')
            
            var quantity = durationToBlockCount(
                dateTimeStart, 
                dateTimeEnd, 
                service.getBlockTotalLength()
            );
            var totalPrice = formatCurrency(reservation.totalPrice, false);
            var price = totalPrice / quantity;
            var totalPriceTax = quantity * (price - (price / ((reservation.taxRate / 100)+1)));
            
            const data = {
                orderId: reservation.orderId,
                orderProductId: reservation.orderProductId,
                reservationTimeId: reservation.reservationTimeId,
                dateTimeStart: dateTimeStart.format('YYYY-MM-DD HH:mm:ss'),
                dateTimeEnd: dateTimeEnd.format('YYYY-MM-DD HH:mm:ss'),
                resourceId: -(-this.resourceId),
                resourceName: this.getResourceName(),
                totalPrice,
                totalPriceTax,
                quantity,
                price
            };
            
            return data;
        },
    },
    mounted() {
        this.setResourceId(this.defaultResourceId)
        this.setStartTime(this.defaultDate)
    }
}
</script>